module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Tabs")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("标签页")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _c('h3', [_vm._v("Tabs")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("TabPane")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签类型，可选值"), _c('code', [_vm._v("padding/no_padding/fix_width/fix_width:String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("padding")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("active-style")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("选中时标签样式")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("shouldChange")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签切换前调用，返回false时则不切换标签[@params: name, vm]")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("标签Value，用于识别当前面板，默认为索引值")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("icon")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("前置图标")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁用标签")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503b0ff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-25.vue
// module id = 658
// module chunks = 0